import type { DiTypes } from "@iot-platform/core";

export const campaignTypes = Object.seal({
    repositories: {
        CampaignRepository: Symbol.for("CampaignRepository"),
    },
} satisfies DiTypes);
